import { z } from 'zod';

export const APP_ICON_CHOICE_GET_CHANNEL = 'app-icon-choice:get';

export const APP_ICON_CHOICE_SET_CHANNEL = 'app-icon-choice:set';

export const APP_ICON_CHOICES = [
  'original',
  'blue',
  'yellow',
  'dark',
  'sky',
  'astronaut',
  'person',
  'pixel',
  'editorial',
] as const;

export const AppIconChoiceSchema = z.enum(APP_ICON_CHOICES);

export type AppIconChoice = z.infer<typeof AppIconChoiceSchema>;
